import React, { ReactNode, CSSProperties, useMemo } from 'react';

interface IProps {
	children?: ReactNode | ReactNode[] | undefined,
	className?: string | undefined,
	style?: CSSProperties | undefined
}

function ElevatedContainer(props: IProps) {

	const className = useMemo(() => {
		return `elevated-container ${props.className}`
	}, [props.className]);;

	return (
		<div
			className={className}
			style={props.style}
		>
			{props.children}
		</div>
	);
};

export default ElevatedContainer;